// **** Regras de Funcionamento | Dias/Horários | Feriados | Colaboradores ****
// p_regras.jsx ****
// **** autor: Walcledson de Paula ****
// **** 08-11-24 | 20h52 ****
// **** 09-12-24 | 15h43 | correção da falha na função "fetchCarregaIntervaloAtendimento" ****




import { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import Swal from "sweetalert2";
import Icon from '@mdi/react';
import { mdiPlusCircleOutline, mdiMinusCircleOutline } from '@mdi/js';
import apiaxios from "../../../../../Services/apiaxios.js";
import handleApiError from '../../../../../Services/apiErrorHandler.js';
import { encrypt, decrypt } from "../../../../../Services/cryptoUtils.js";
import { p_getUserData } from "../../../../../Services/p_userutils.js";
import { useCarregaDados } from "../../../Hooks/usecarregadados.jsx";
import { AutoLogout } from "../../../../../Services/autologout.js";
import { Container, Row, Col, Button } from 'react-bootstrap'; // Certifique-se de importar os componentes corretamente

import Menu from "../../../Components/Menu/p_menu.jsx";
// import MenuConfig from "../../../Components/Menu/p_menuconfig.jsx";
import Footer from "../../../../AgendexCliente/components/Footer/footer.jsx";

import './p_regras.css';

function Regras() {
    // verifica se os tokens estão presentes e não corrompidos/vencidos
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    useEffect(() => {
        const tokenLG = localStorage.getItem("tokenlg");
        
        if (!tokenASW || !tokenLG) {
            AutoLogout();
        }
    }, [tokenASW]);

    const initialUserData = p_getUserData();
    const [id_usuario, setId_usuario] = useState(initialUserData.userId);
    const [indEmpresa, setIndEmpresa] = useState(initialUserData.indEmpresa);
    const [emailValidado, setEmailValidado] = useState(initialUserData.emailValidado);
    const [validado, setvalidado] = useState(initialUserData.validado); // CPF/CNPJ validado =1 (se ainda não foi validado = 0)
    const [tipoAtendimento, setTipoAtendimento] = useState(initialUserData.tipoAtendimento); // 0 = não possui colaboradores, 1 = possui colaboradores
    const [agendaFechada, setAgendaFechada] = useState(initialUserData.agenda_fechada);  // 0 = Aberta, 1 = Fechada
    const [tipoAgenda, setTipoAgenda] = useState(initialUserData.tipoAgenda); // 0 = Global, 1 = Individual
    const [lock, setLock] = useState(initialUserData.bloqueio);  // 0 = prestador liberado, 1 = prestador bloqueado por fim de contrato // linha acima

    const [qtServicos, setQTServicos] = useState(0); // total de serviços cadastrados
    const [qtServicosAvulsos, setQTServicosAvulsos] = useState(0); // total de serviços cadastrados disponíveis pra agendamento avulso
    // const [intervaloAtendimentos, setIntervaloAtendimentos] = useState(0);
    const [intervalo, setIntervalo] = useState({
        valor: 0,
        minimo: 30,
        maximo: 120,
    });
    const { valor, minimo, maximo } = intervalo;
    const prevValor = useRef(valor);
    
    const { loading, setLoading, MySwal } = useCarregaDados();
    const navigate = useNavigate();

    useEffect(() => {
        fetchCarregaIntervaloAtendimento();
        // console.log('useeffect carrega intervalo atendimento');
    }, []);

    // Atualizando a referência `prevValor` para o estado anterior do `valor`
    useEffect(() => {
        if (prevValor.current !== valor) {
            toggleIntervaloAtendimento();
            prevValor.current = valor; // Atualiza `prevValor` após a chamada à API
        }
    }, [valor]);


    // carrega o intervalo de atendimento salvo na tabela
    const fetchCarregaIntervaloAtendimento = async () => {
        // console.log ('dentro do início fetch carregaintervaloatendimento');
        setLoading(true);
        // console.log ('variáveis id_empresa, token, id_usuario: ', id_usuario, tokenASW, id_usuario);
        try {
            const response = await apiaxios.get('/configuracao/IntervaloAgendaWeb', {
                params: { id_empresa: id_usuario,
                        token: tokenASW,
                        id_usuario 
                }
            });
            // console.log ('fetch carregaintervaloatendimento antes da resposta');
            if (response.status === 200) {
                const data = response.data;
                // console.log ('data fetch carregaintervaloatendimento' , data);
                if (data.retorno === 'OK') {
                    // setIntervalo(data.intervalo_agenda);
                    // // setIntervaloAtendimentos(data.intervalo_agenda);
                    // console.log('intervalo antes ', intervalo);
                    // console.log('valor antes ', valor);
                    setIntervalo({
                        ...intervalo,
                        valor: Number(response.data.tempoAgendaMinutos, 30)
                    });
                    // console.log('intervalo pós ', intervalo);
                    // console.log('valor pós ', valor);
 
                    // Atualizar prevValorRef com o valor inicial
                    prevValor.current = Number(response.data.tempoAgendaMinutos, 30);
                } else {
                    Swal.fire('Erro', data.retorno, 'error');
                }
            } else {
                Swal.fire('Erro', 'Falha ao carregar "Intervalo de Atendimento" sua empresa. Tente novamente mais tarde.', 'error');
            }
        } catch (error) {
            // console.log('catch error ', error);
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    // Função para chamar a página para criar ou editar horários de atendimento;
    const toggleHorarios = async () => {
        navigate('/app/prestador/empresa/regras/horarios');
    };

    // Função para chamar a página para criar ou editar feriados e/ou exceções que não trabalhará;
    const toggleFeriados = async () => {
        navigate('/app/prestador/empresa/regras/feriados');
    };

    // Função para alternar o tipo de atendimento
    const toggleTipoAtendimento = async () => {
        const novoStatus = tipoAtendimento === 0 ? 1 : 0;
        setTipoAtendimento(novoStatus);
        setLoading(true);
        try {
            const response = await apiaxios.put('configuracao/tipoAtendimentoWeb', {
                id_usuario,
                tipoatendimento: novoStatus
            }, {params: {id_usuario,
                    token: tokenASW,
                }}
            );
    
            if (response.status === 200 && response.data.retorno === 'OK') {
                // MySwal.fire('Tipo Atendimento', '"Atendimento com ou sem Colaborador" alterado com sucesso!', 'info');
                MySwal.fire({ title: 'Sucesso!', text: '"Atendimento com ou sem Colaborador" alterado com sucesso!', icon: 'success', toast: true, timer: 3000 });
                const encryptedToken = localStorage.getItem('tokenapw');
                const token = decrypt(encryptedToken);
                token.tipoAtendimento = novoStatus;
                const updatedEncryptedToken = encrypt(token);
                localStorage.setItem('tokenapw', updatedEncryptedToken);
            } else {
                throw new Error(response.data.retorno || 'Falha ao carregar seus dados.');
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };
   
    const toggleIntervaloAtendimento = async () => {
        setLoading(true);
        try {
            const response = await apiaxios.put('configuracao/IntervaloAgendaWeb', {
                id_empresa: id_usuario,
                // intervalo_agenda: valor
                tempoAgendaMinutos: valor
                // tempoAgendaMinutos: intervaloAtendimentos
            }, {params: {id_usuario,
                    token: tokenASW,
                }}
            );
    
            if (response.status === 200 && response.data.retorno === 'OK') {
                // MySwal.fire('Intervalo Atendimento', '"Intervalo de Atendimento" alterado com sucesso!', 'info');
                MySwal.fire({ title: 'Sucesso!', text: '"Intervalo de Atendimento" alterado com sucesso!', icon: 'success', toast: true, timer: 3000 });
                // const encryptedToken = localStorage.getItem('tokenapw');
                // const token = decrypt(encryptedToken);
                // token.intervaloAtendimento = intervaloAtendimentos;
                // const updatedEncryptedToken = encrypt(token);
                // localStorage.setItem('tokenapw', updatedEncryptedToken);
            } else {
                throw new Error(response.data.retorno || 'Falha ao alterar o "Intervalo de Atendimento".');
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }        
    };

    const handleIncrementarIntervalo = () => {
        setIntervalo((prevState) => {
            // const newValue = Math.min(prevState.valor + 30, maximo);
            const newValue = Math.min(parseInt(prevState.valor) + 30, maximo); // parseInt para garantir que seja inteiro (integer) e não uma string 9/11/24w
            // console.log('Estado anterior:', prevState);
            // console.log('Novo valor calculado:', newValue);
            // console.log('Valor máximo:', maximo);
            return {
                ...prevState,
                valor: newValue,
            };
        });
    };

    // 4. Função para decrementar o intervalo, mantendo-o no limite mínimo
    const handleDecrementarIntervalo = () => {
        setIntervalo((prevState) => ({
            ...prevState,
            valor: Math.max(parseInt(prevState.valor) - 30, minimo),
        }));
    };    



    return (
        <>
            <div className="topo-margin">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <Menu page='regras' />
                        </div>
                        <div className="col py-2 me-3">
                            <h1 className="text-center">Regras de Atendimento</h1>
                            <hr />

                            <div className="container-fluid">

                                {/* Agendamento com ou sem colaboradores */}
                                <Row className="mt-3 text-center">
                                    <Col>
                                        <h4>Tipo de Atendimento</h4>
                                        <Button
                                            variant={tipoAtendimento === 1 ? 'success' : 'secondary'}
                                            className="me-2"
                                            onClick={toggleTipoAtendimento}
                                        >
                                            Com Colaboradores
                                        </Button>
                                        <Button
                                            variant={tipoAtendimento === 0 ? 'success' : 'secondary'}
                                            onClick={toggleTipoAtendimento}
                                        >
                                            Sem Colaboradores
                                        </Button>
                                    </Col>
                                </Row>
                                {/* Agendamento com ou sem colaboradores */}
                                <hr />
                                
                                {/* <Container> */}
                                    {/* Botão "Intervalo de Atendimento" */}
                                    <Row className="mt-3 text-center">
                                        <Col>
                                            <h4>Intervalo de Atendimentos</h4>

                                            {/* botão para diminuir o intervalo de atendimentos (mínimo 30 minutos) */}
                                            <Button
                                                variant={'warning'}
                                                className="me-2 btn-lg"
                                                // onClick={toggleIntervaloAtendimentoMinus}
                                                onClick={handleDecrementarIntervalo}
                                            >
                                                <Icon path={mdiMinusCircleOutline} size={1}/>
                                            </Button>

                                            {/* botão que contém o valor atual do intervalo salvo na tabela */}
                                            <Button
                                                className="btn-lg"
                                                disabled
                                                variant={'dark'}
                                            >
                                                {/* {intervaloAtendimentos} */}
                                                {valor}
                                            </Button>

                                            {/* botão para aumentar o intervalo de atendimentos (máixmo 120 minutos=2 horas) */}
                                            <Button
                                                className="ms-2 btn-lg"
                                                variant={'primary btn-lg'}
                                                // onClick={toggleIntervaloAtendimentoMais}
                                                onClick={handleIncrementarIntervalo}
                                            >
                                                <Icon path={mdiPlusCircleOutline} size={1}/>
                                            </Button>
                                        </Col>
                                    </Row>
                                    {/* Botão "Intervalo de Atendimento" */}
                                {/* </Container> */}

                                <hr />
                                <Container>
                                    {/* Botão "Dias/Horários de Funcionamento" */}
                                    <Row className="mt-3 text-center">
                                        <Col>
                                            <Button disabled={ tipoAtendimento ===1 } variant="success" className="btn-lg"
                                                onClick={toggleHorarios}
                                            >
                                                <div><h1>Dias/Horários de Funcionamento</h1></div>
                                                {/* <div>{qtServicos} Cadastrados</div> Esse valor xx será atualizado dinamicamente depois */}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Container>

                                <Container>
                                    {/* Botão "Feriados que não atende" */}
                                    <Row className="mt-3 text-center">
                                        <Col>
                                            <Button variant="success" className="btn-lg"
                                                onClick={toggleFeriados}
                                            >
                                                <div><h1>Feriados que não atende</h1></div>
                                                {/* <div>{qtServicos} Cadastrados</div> Esse valor xx será atualizado dinamicamente depois */}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Container>          

                                <div className="row">
                                    <div className={`row ${loading ? 'd-none' : ''}`}></div>
                                    {loading && (
                                        <div className="loading-spinner-container">
                                            <Oval color="#00BFFF" height={80} width={80} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Regras;